// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3nQ_U","label":"SetPasswdForm_label__1Ie6Z"};